import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import Slider from "react-slick";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import client1 from '../../images/1 (3).jpg';
import client2 from '../../images/2.jpg';
import client3 from '../../images/3.jpg';
import './Testimonials.css';

const Testimonials = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            }
          ]

    };
    return (
        <Box sx={{ p: { xs: 2, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: {xs: '18px',sm:'21px'}, color: 'primary.main' }}>Testimonials</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: {xs: '25px',sm:'47px'} }}>What people say <br /> about me</Typography>
            </Box>

            <Box>
                <Slider {...settings}>
                    
                    <Box>
                        <Paper elevation={5} sx={{ borderRadius: '10px', p: {xs: 2,md: 5}, m: {xs: 1, md: 3} }}>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: '300', color: 'muted.main' }}>These people really know what they are doing! Great customer support availability and supperb kindness. I am very happy that I've purchased this liscense!!!</Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <img src={client1} style={{ width: '60px', height: '60px', borderRadius: '100%' }} alt="" />
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px' }}>Jacob Oramson</Typography>
                                        <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '18px', color: 'muted.main' }}>Designer</Typography>
                                    </Box>
                                </Box>
                                <FormatQuoteIcon sx={{ fontSize: {xs: '50px',sm:'100px'}, color: 'secondary.main', transform: 'rotate(180deg)' }} />
                            </Box>
                        </Paper>
                    </Box>
                    
                    <Box>
                        <Paper elevation={5} sx={{ borderRadius: '10px', p: {xs: 2,md: 5}, m: {xs: 1, md: 3} }}>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: '300', color: 'muted.main' }}>These people really know what they are doing! Great customer support availability and supperb kindness. I am very happy that I've purchased this liscense!!!</Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <img src={client1} style={{ width: '60px', height: '60px', borderRadius: '100%' }} alt="" />
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px' }}>Jacob Oramson</Typography>
                                        <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '18px', color: 'muted.main' }}>Designer</Typography>
                                    </Box>
                                </Box>
                                <FormatQuoteIcon sx={{ fontSize: {xs: '50px',sm:'100px'}, color: 'secondary.main', transform: 'rotate(180deg)' }} />
                            </Box>
                        </Paper>
                    </Box>
                    
                    <Box>
                        <Paper elevation={5} sx={{ borderRadius: '10px', p: {xs: 2,md: 5}, m: {xs: 1, md: 3} }}>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: '300', color: 'muted.main' }}>These people really know what they are doing! Great customer support availability and supperb kindness. I am very happy that I've purchased this liscense!!!</Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <img src={client1} style={{ width: '60px', height: '60px', borderRadius: '100%' }} alt="" />
                                    <Box>
                                        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px' }}>Jacob Oramson</Typography>
                                        <Typography variant='h6' sx={{ fontWeight: 300, fontSize: '18px', color: 'muted.main' }}>Designer</Typography>
                                    </Box>
                                </Box>
                                <FormatQuoteIcon sx={{ fontSize: {xs: '50px',sm:'100px'}, color: 'secondary.main', transform: 'rotate(180deg)' }} />
                            </Box>
                        </Paper>
                    </Box>

                    


                </Slider>
            </Box>

        </Box>
    );
};

export default Testimonials;